import axios from 'axios';

export default {
    getAll() {
        return axios.get(window.API_BASE + '/xero-links');
    }
}